import { Directive, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { getCurrentUserIsSystemUser } from 'src/app/authentication/state/authentication.selector';
import { getIsOnSystemPage, getSelectedAccountName } from 'src/app/store/select-account/select-account.selector';
import { FormsBase } from '../forms-base/forms-base';

@Directive()
export abstract class Detail<FormService extends FormsBase> implements OnDestroy {
   selectedAccount$: Observable<string | null>;

   isOnSystemPage$: Observable<boolean | undefined>;

   callState$: Observable<CallState>;

   isSystemUser$: Observable<boolean>;

   destroyed$ = new Subject<void>();

   form: UntypedFormGroup | undefined;

   constructor(public store: Store, protected formService?: FormService) {
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      this.isOnSystemPage$ = this.store.pipe(select(getIsOnSystemPage));
      this.selectedAccount$ = this.store.pipe(select(getSelectedAccountName));
      if (formService) {
         this.form = this.formService?.form;
      }
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}

@Directive()
export abstract class NavigatableDetail<FormService extends FormsBase> extends Detail<FormService> {
   idsFromRegister$: Observable<string[] | number[]>;

   totalCount$: Observable<number>;
}
